import { render, staticRenderFns } from "./SettingsLayout.vue?vue&type=template&id=3561d59e&scoped=true&lang=pug&"
import script from "./SettingsLayout.vue?vue&type=script&lang=js&"
export * from "./SettingsLayout.vue?vue&type=script&lang=js&"
import style0 from "./SettingsLayout.vue?vue&type=style&index=0&id=3561d59e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3561d59e",
  null
  
)

export default component.exports